import React from 'react'
import BEM from '@iui-kit/utils/bem'

const bem = new BEM(require('./Tooltip.css'))

interface Props {
  className: string
  position?: string
}

const Tooltip: React.FC<Props> = ({ className, position, children }) => {
  return (
    <div
      className={bem
        .b('Tooltip')
        .m(position)
        .mix(className)
        .show()}
    >
      {children}
    </div>
  )
}

Tooltip.defaultProps = {
  className: '',
  position: 'top'
}

export default Tooltip
